var _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use0, _use1, _use10, _use11, _use12, _use13, _use14, _use15, _use16, _use17, _use18, _use19, _use20, _use21, _use22, _use23, _use24, _use25, _use26, _use27, _use28, _use29, _use30, _use31, _use32, _use33, _use34, _use35, _use36, _use37, _use38, _use39, _use40, _use41, _use42, _use43, _use44, _use45, _use46, _use47, _use48, _use49, _use50, _use51, _use52, _use53, _use54, _use55, _use56, _use57, _use58, _use59, _use60, _use61, _use62, _use63, _use64, _use65, _use66, _use67, _use68, _use69, _use70, _use71, _use72, _use73, _use74, _use75, _use76, _use77, _use78, _use79, _use80, _use81, _use82, _use83, _use84, _use85, _use86, _use87, _use88, _use89, _use90, _use91, _use92, _use93, _use94, _use95, _use96, _use97, _use98, _use99, _use100, _use101, _use102, _use103, _use104, _use105, _use106, _use107, _use108, _use109, _use110, _use111, _use112, _use113, _use114, _use115, _use116, _use117, _use118, _use119, _use120, _use121, _use122, _use123, _use124, _use125, _use126, _use127, _use128, _use129, _use130, _use131, _use132, _use133, _use134, _use135, _use136, _use137, _use138, _use139, _use140, _use141, _use142, _use143, _use144, _use145, _use146, _use147, _use148, _use149, _use150, _use151, _use152, _use153, _use154, _use155, _use156, _use157, _use158, _use159, _use160, _use161, _use162, _use163, _use164, _use165, _use166, _use167, _use168, _use169, _use170, _use171, _use172, _use173, _use174, _use175, _use176, _use177, _use178, _use179, _use180, _use181, _use182, _use183, _use184, _use185, _use186, _use187, _use188, _use189, _use190, _use191, _use192, _use193, _use194, _use195, _use196, _use197, _use198, _use199, _use200, _use201, _use202, _use203, _use204, _use205, _use206, _use207, _use208, _use209, _use210, _use211, _use212, _use213, _use214, _use215, _use216, _use217, _use218, _use219, _use220, _use221, _use222, _use223, _use224, _use225, _use226, _use227;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPearsonLogoPurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 777.357,
    height: 155.771,
    viewBox: "0 0 583.018 116.828",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 39.72,
    y: 10.44,
    transform: "translate(-6.405 -41.792)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 39.72,
    y: 36.84,
    transform: "translate(-6.405 -41.792)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 555.24,
    y: 94.797,
    transform: "translate(-6.405 -41.792)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 299.395,
    y: 796.56,
    transform: "translate(-6.405 -41.792)"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    x: 39.72,
    y: 820.56,
    fill: "#0d004d",
    transform: "translate(-6.405 -41.792)"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 541.91,
    y: 65.04,
    transform: "translate(-6.405 -41.792)"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    x: 522.36,
    y: 85.08,
    transform: "translate(-6.405 -41.792)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0d004d",
    d: "M32.56 10.283v.018s2.28 17.384 2.28 47.055c0 29.672-2.28 47.074-2.28 47.055v.019c11.644-12.325 18.78-28.863 18.78-47.074v-.018c0-18.193-7.137-34.749-18.781-47.055",
    style: {
      strokeWidth: 4.70918
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0d004d",
    d: "M32.964 41.444c-2.428-9.197-7.008-17.88-13.336-25.753C14.2 9.621 7.616 4.304.148 0 7.375 11.423 12.25 32.78 12.25 57.246S7.395 103.013.166 114.455l-.166.386a81.7 81.7 0 0 0 11.626-8.075c12.325-11.7 20.437-25.754 22.718-41.022.331-2.722.497-5.5.497-8.296 0-5.518-.644-10.871-1.877-16.004m433.244-6.383c-23.196 0-41.665 18.101-41.665 40.893 0 22.791 18.414 40.819 41.592 40.819s41.591-18.046 41.591-40.838c0-22.791-18.34-40.874-41.536-40.874zm-.055 63.353c-13.336 0-21.54-10.32-21.54-22.46s8.222-22.48 21.54-22.48c13.3 0 21.522 10.32 21.522 22.461s-8.222 22.48-21.522 22.48M174.662 35.061c-22.994 0-39.604 18.506-39.623 41.003 0 22.02 15.912 40.764 39.016 40.764 16.648 0 31.824-9.97 37.563-25.496h-20.234c-3.127 4.158-9.271 7.69-17.218 7.69-12.656 0-18.395-9.014-19.058-15.894h57.835c.331-2.207.515-5.887.515-8.443 0-23.84-17.567-39.624-38.796-39.624m-19.517 33.056c0-8.535 8.425-15.433 18.837-15.433 10.393 0 18.818 6.898 18.818 15.433zm392.572-33.056c-19.517 0-35.3 15.728-35.3 35.209v44.571h19.793V70.288c0-10.062 7.174-16.464 15.47-16.464 8.297 0 15.434 6.457 15.416 16.52l-.037 44.497h19.959V70.288c.018-19.48-15.783-35.227-35.3-35.227M360.95 37.545c-2.188-1.012-6.916-2.484-12.342-2.484-15.6 0-21.67 11.976-22.332 13.3V37.048H307.53l-.055 77.775h19.775V63.942c.552-1.049 6.107-10.504 17.604-10.504 4.286 0 8.204 1.325 9.198 1.821zm-101.835-2.484c-23.013 0-41.739 17.899-41.739 41.242 0 21.835 16.409 40.562 38.593 40.525 11.166-.018 19.96-4.801 24.54-11.718v9.731h20.05l-.018-39.917c-.019-22.48-18.745-39.863-41.426-39.863m-.147 63.61c-13.318 0-21.541-10.466-21.541-22.607s8.223-22.626 21.54-22.626c13.319 0 21.542 10.485 21.542 22.626s-8.223 22.608-21.541 22.608m137.688-30.279c-13.153-2.777-18.414-3.936-18.414-8.388 0-5.04 6.733-7.67 13.852-7.67 10.798 0 18.8 6.051 19.683 6.714l9.86-14.422c-5.06-3.385-14.643-9.566-29.727-9.566-20.915 0-33.075 11.884-33.075 25.128 0 13.944 13.466 20.53 28.936 23.785 11.828 2.483 15.452 3.44 15.452 7.597 0 5.684-6.751 7.984-13.613 7.984-10.577 0-19.37-5.464-24.686-11.148l-11.019 14.257c4.6 4.36 16.482 14.146 35.374 14.146s33.848-10.706 33.848-23.988c0-16.059-11.02-21.154-26.471-24.429M102.112 0H63.059l-.019 114.841h19.665l.018-41.389h19.389c22.847 0 38.133-15.728 38.133-36.717S124.959 0 102.112 0m-2.465 54.763H82.723V18.69h16.924c13.484 0 20.547 7.21 20.547 18.045 0 10.817-7.063 18.028-20.547 18.028",
    style: {
      strokeWidth: 4.70918
    }
  }), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 112.554,
    y: 133.68,
    fill: "#0d004d",
    transform: "translate(-6.405 -41.792)"
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 177.822,
    y: 133.68,
    fill: "#0d004d",
    transform: "translate(-6.405 -41.792)"
  })), _use0 || (_use0 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: 512.046,
    y: 133.68,
    fill: "#0d004d",
    transform: "translate(-6.405 -41.792)"
  })), _use1 || (_use1 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    x: 65.52,
    y: 154.2,
    fill: "#512eab",
    transform: "translate(-6.405 -41.792)"
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    x: 102.595,
    y: 154.2,
    fill: "#512eab",
    transform: "translate(-6.405 -41.792)"
  })), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    x: 146.16,
    y: 154.2,
    transform: "translate(-6.405 -41.792)"
  })), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    x: 39.72,
    y: 171.48,
    transform: "translate(-6.405 -41.792)"
  })), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    x: 204.136,
    y: 192.237,
    transform: "translate(-6.405 -41.792)"
  })), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i",
    x: 325.708,
    y: 203.272,
    transform: "translate(-6.405 -41.792)"
  })), _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i",
    x: 465.045,
    y: 203.272,
    transform: "translate(-6.405 -41.792)"
  })), _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    x: 501.237,
    y: 203.272,
    transform: "translate(-6.405 -41.792)"
  })), _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    x: 538.68,
    y: 203.272,
    transform: "translate(-6.405 -41.792)"
  })), _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    x: 317.188,
    y: 214.188,
    transform: "translate(-6.405 -41.792)"
  })), _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i",
    x: 351.747,
    y: 214.188,
    transform: "translate(-6.405 -41.792)"
  })), _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    x: 381.836,
    y: 214.188,
    transform: "translate(-6.405 -41.792)"
  })), _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    x: 472.577,
    y: 214.188,
    transform: "translate(-6.405 -41.792)"
  })), _use22 || (_use22 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    x: 528.955,
    y: 214.188,
    transform: "translate(-6.405 -41.792)"
  })), _use23 || (_use23 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    x: 549.114,
    y: 214.188,
    transform: "translate(-6.405 -41.792)"
  })), _use24 || (_use24 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i",
    x: 548.687,
    y: 225.224,
    transform: "translate(-6.405 -41.792)"
  })), _use25 || (_use25 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    x: 278.757,
    y: 236.26,
    transform: "translate(-6.405 -41.792)"
  })), _use26 || (_use26 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    x: 550.084,
    y: 236.26,
    transform: "translate(-6.405 -41.792)"
  })), _use27 || (_use27 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    x: 252.595,
    y: 247.176,
    transform: "translate(-6.405 -41.792)"
  })), _use28 || (_use28 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    x: 526.916,
    y: 247.176,
    transform: "translate(-6.405 -41.792)"
  })), _use29 || (_use29 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    x: 362.291,
    y: 258.212,
    transform: "translate(-6.405 -41.792)"
  })), _use30 || (_use30 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    x: 542.67,
    y: 258.212,
    transform: "translate(-6.405 -41.792)"
  })), _use31 || (_use31 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    x: 178.443,
    y: 269.247,
    transform: "translate(-6.405 -41.792)"
  })), _use32 || (_use32 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j",
    x: 197.4,
    y: 295.92,
    fill: "#512eab",
    transform: "translate(-6.405 -41.792)"
  })), _use33 || (_use33 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    x: 39.72,
    y: 311.04,
    transform: "translate(-6.405 -41.792)"
  })), _use34 || (_use34 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    x: 125.4,
    y: 321.12,
    transform: "translate(-6.405 -41.792)"
  })), _use35 || (_use35 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k",
    x: 47.042,
    y: 336.36,
    transform: "translate(-6.405 -41.792)"
  })), _use36 || (_use36 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 71.28,
    y: 336.36,
    transform: "translate(-6.405 -41.792)"
  })), _use37 || (_use37 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 181.804,
    y: 336.36,
    transform: "translate(-6.405 -41.792)"
  })), _use38 || (_use38 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 352.94,
    y: 336.36,
    transform: "translate(-6.405 -41.792)"
  })), _use39 || (_use39 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    x: 523.922,
    y: 336.36,
    transform: "translate(-6.405 -41.792)"
  })), _use40 || (_use40 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 169.933,
    y: 348.96,
    transform: "translate(-6.405 -41.792)"
  })), _use41 || (_use41 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 282.26,
    y: 348.96,
    transform: "translate(-6.405 -41.792)"
  })), _use42 || (_use42 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 325.461,
    y: 348.96,
    transform: "translate(-6.405 -41.792)"
  })), _use43 || (_use43 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 491.565,
    y: 348.96,
    transform: "translate(-6.405 -41.792)"
  })), _use44 || (_use44 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    x: 107.88,
    y: 361.56,
    transform: "translate(-6.405 -41.792)"
  })), _use45 || (_use45 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 109.32,
    y: 361.56,
    transform: "translate(-6.405 -41.792)"
  })), _use46 || (_use46 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    x: 39.72,
    y: 374.64,
    fill: "#512eab",
    transform: "translate(-6.405 -41.792)"
  })), _use47 || (_use47 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    x: 197.397,
    y: 384.6,
    fill: "#512eab",
    transform: "translate(-6.405 -41.792)"
  })), _use48 || (_use48 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k",
    x: 47.04,
    y: 399.48,
    transform: "translate(-6.405 -41.792)"
  })), _use49 || (_use49 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 122.155,
    y: 399.84,
    transform: "translate(-6.405 -41.792)"
  })), _use50 || (_use50 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 241.551,
    y: 399.84,
    transform: "translate(-6.405 -41.792)"
  })), _use51 || (_use51 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 258.96,
    y: 399.84,
    transform: "translate(-6.405 -41.792)"
  })), _use52 || (_use52 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 464.284,
    y: 399.84,
    transform: "translate(-6.405 -41.792)"
  })), _use53 || (_use53 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 505.084,
    y: 399.84,
    transform: "translate(-6.405 -41.792)"
  })), _use54 || (_use54 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 77.52,
    y: 412.44,
    transform: "translate(-6.405 -41.792)"
  })), _use55 || (_use55 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 116.397,
    y: 412.44,
    transform: "translate(-6.405 -41.792)"
  })), _use56 || (_use56 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 136.193,
    y: 412.44,
    transform: "translate(-6.405 -41.792)"
  })), _use57 || (_use57 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 151.433,
    y: 412.44,
    transform: "translate(-6.405 -41.792)"
  })), _use58 || (_use58 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 160.433,
    y: 412.44,
    transform: "translate(-6.405 -41.792)"
  })), _use59 || (_use59 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 221.868,
    y: 412.44,
    transform: "translate(-6.405 -41.792)"
  })), _use60 || (_use60 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 289.425,
    y: 412.44,
    transform: "translate(-6.405 -41.792)"
  })), _use61 || (_use61 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 328.78,
    y: 412.44,
    transform: "translate(-6.405 -41.792)"
  })), _use62 || (_use62 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 359.86,
    y: 412.44,
    transform: "translate(-6.405 -41.792)"
  })), _use63 || (_use63 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 386.736,
    y: 412.44,
    transform: "translate(-6.405 -41.792)"
  })), _use64 || (_use64 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 525.737,
    y: 412.44,
    transform: "translate(-6.405 -41.792)"
  })), _use65 || (_use65 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 161.28,
    y: 425.04,
    transform: "translate(-6.405 -41.792)"
  })), _use66 || (_use66 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 320.88,
    y: 425.04,
    transform: "translate(-6.405 -41.792)"
  })), _use67 || (_use67 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k",
    x: 56.4,
    y: 443.4,
    transform: "translate(-6.405 -41.792)"
  })), _use68 || (_use68 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 65.16,
    y: 443.4,
    transform: "translate(-6.405 -41.792)"
  })), _use69 || (_use69 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 131.166,
    y: 443.4,
    transform: "translate(-6.405 -41.792)"
  })), _use70 || (_use70 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 157.202,
    y: 443.4,
    transform: "translate(-6.405 -41.792)"
  })), _use71 || (_use71 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 305.035,
    y: 443.4,
    transform: "translate(-6.405 -41.792)"
  })), _use72 || (_use72 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 336.106,
    y: 443.4,
    transform: "translate(-6.405 -41.792)"
  })), _use73 || (_use73 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 397.2,
    y: 443.4,
    transform: "translate(-6.405 -41.792)"
  })), _use74 || (_use74 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 415.08,
    y: 443.4,
    transform: "translate(-6.405 -41.792)"
  })), _use75 || (_use75 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 434.876,
    y: 443.4,
    transform: "translate(-6.405 -41.792)"
  })), _use76 || (_use76 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 105.004,
    y: 468.6,
    transform: "translate(-6.405 -41.792)"
  })), _use77 || (_use77 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 126.486,
    y: 468.6,
    transform: "translate(-6.405 -41.792)"
  })), _use78 || (_use78 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 159.485,
    y: 468.6,
    transform: "translate(-6.405 -41.792)"
  })), _use79 || (_use79 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 204.126,
    y: 468.6,
    transform: "translate(-6.405 -41.792)"
  })), _use80 || (_use80 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 363.72,
    y: 468.6,
    transform: "translate(-6.405 -41.792)"
  })), _use81 || (_use81 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 365.4,
    y: 468.6,
    transform: "translate(-6.405 -41.792)"
  })), _use82 || (_use82 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k",
    x: 53.16,
    y: 486.84,
    transform: "translate(-6.405 -41.792)"
  })), _use83 || (_use83 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 65.16,
    y: 486.84,
    transform: "translate(-6.405 -41.792)"
  })), _use84 || (_use84 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 222.846,
    y: 486.84,
    transform: "translate(-6.405 -41.792)"
  })), _use85 || (_use85 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 293.996,
    y: 486.84,
    transform: "translate(-6.405 -41.792)"
  })), _use86 || (_use86 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 459.463,
    y: 486.84,
    transform: "translate(-6.405 -41.792)"
  })), _use87 || (_use87 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 511.538,
    y: 486.84,
    transform: "translate(-6.405 -41.792)"
  })), _use88 || (_use88 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 108.721,
    y: 499.44,
    transform: "translate(-6.405 -41.792)"
  })), _use89 || (_use89 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 120.842,
    y: 499.44,
    transform: "translate(-6.405 -41.792)"
  })), _use90 || (_use90 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 149.401,
    y: 499.44,
    transform: "translate(-6.405 -41.792)"
  })), _use91 || (_use91 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 197.401,
    y: 499.44,
    transform: "translate(-6.405 -41.792)"
  })), _use92 || (_use92 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 226.802,
    y: 499.44,
    transform: "translate(-6.405 -41.792)"
  })), _use93 || (_use93 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 243.363,
    y: 499.44,
    transform: "translate(-6.405 -41.792)"
  })), _use94 || (_use94 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 291.246,
    y: 499.44,
    transform: "translate(-6.405 -41.792)"
  })), _use95 || (_use95 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 301.087,
    y: 499.44,
    transform: "translate(-6.405 -41.792)"
  })), _use96 || (_use96 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 318.607,
    y: 499.44,
    transform: "translate(-6.405 -41.792)"
  })), _use97 || (_use97 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 356.406,
    y: 499.44,
    transform: "translate(-6.405 -41.792)"
  })), _use98 || (_use98 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    x: 514.072,
    y: 499.44,
    transform: "translate(-6.405 -41.792)"
  })), _use99 || (_use99 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 93.72,
    y: 510.84,
    transform: "translate(-6.405 -41.792)"
  })), _use100 || (_use100 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k",
    x: 53.16,
    y: 528.72,
    transform: "translate(-6.405 -41.792)"
  })), _use101 || (_use101 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 65.16,
    y: 528.72,
    transform: "translate(-6.405 -41.792)"
  })), _use102 || (_use102 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 79.2,
    y: 528.72,
    transform: "translate(-6.405 -41.792)"
  })), _use103 || (_use103 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 177.483,
    y: 528.72,
    transform: "translate(-6.405 -41.792)"
  })), _use104 || (_use104 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 203.522,
    y: 528.72,
    transform: "translate(-6.405 -41.792)"
  })), _use105 || (_use105 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 252.364,
    y: 528.72,
    transform: "translate(-6.405 -41.792)"
  })), _use106 || (_use106 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 267.484,
    y: 528.72,
    transform: "translate(-6.405 -41.792)"
  })), _use107 || (_use107 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 277.325,
    y: 528.72,
    transform: "translate(-6.405 -41.792)"
  })), _use108 || (_use108 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 329.046,
    y: 528.72,
    transform: "translate(-6.405 -41.792)"
  })), _use109 || (_use109 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 358.206,
    y: 528.72,
    transform: "translate(-6.405 -41.792)"
  })), _use110 || (_use110 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 410.766,
    y: 528.72,
    transform: "translate(-6.405 -41.792)"
  })), _use111 || (_use111 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 424.446,
    y: 528.72,
    transform: "translate(-6.405 -41.792)"
  })), _use112 || (_use112 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 461.888,
    y: 528.72,
    transform: "translate(-6.405 -41.792)"
  })), _use113 || (_use113 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 274.44,
    y: 541.32,
    transform: "translate(-6.405 -41.792)"
  })), _use114 || (_use114 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 434.04,
    y: 541.32,
    transform: "translate(-6.405 -41.792)"
  })), _use115 || (_use115 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k",
    x: 53.16,
    y: 559.68,
    transform: "translate(-6.405 -41.792)"
  })), _use116 || (_use116 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 65.16,
    y: 559.68,
    transform: "translate(-6.405 -41.792)"
  })), _use117 || (_use117 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 94.325,
    y: 559.68,
    transform: "translate(-6.405 -41.792)"
  })), _use118 || (_use118 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 114.125,
    y: 559.68,
    transform: "translate(-6.405 -41.792)"
  })), _use119 || (_use119 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 175.437,
    y: 559.68,
    transform: "translate(-6.405 -41.792)"
  })), _use120 || (_use120 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 512.287,
    y: 559.68,
    transform: "translate(-6.405 -41.792)"
  })), _use121 || (_use121 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 103.797,
    y: 572.28,
    transform: "translate(-6.405 -41.792)"
  })), _use122 || (_use122 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 123.592,
    y: 572.28,
    transform: "translate(-6.405 -41.792)"
  })), _use123 || (_use123 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 256.56,
    y: 572.28,
    transform: "translate(-6.405 -41.792)"
  })), _use124 || (_use124 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 416.16,
    y: 572.28,
    transform: "translate(-6.405 -41.792)"
  })), _use125 || (_use125 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k",
    x: 53.16,
    y: 590.52,
    transform: "translate(-6.405 -41.792)"
  })), _use126 || (_use126 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 65.16,
    y: 590.52,
    transform: "translate(-6.405 -41.792)"
  })), _use127 || (_use127 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 113.879,
    y: 590.52,
    transform: "translate(-6.405 -41.792)"
  })), _use128 || (_use128 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 162.481,
    y: 590.52,
    transform: "translate(-6.405 -41.792)"
  })), _use129 || (_use129 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 190.562,
    y: 590.52,
    transform: "translate(-6.405 -41.792)"
  })), _use130 || (_use130 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 239.402,
    y: 590.52,
    transform: "translate(-6.405 -41.792)"
  })), _use131 || (_use131 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 256.322,
    y: 590.52,
    transform: "translate(-6.405 -41.792)"
  })), _use132 || (_use132 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 266.043,
    y: 590.52,
    transform: "translate(-6.405 -41.792)"
  })), _use133 || (_use133 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 317.765,
    y: 590.52,
    transform: "translate(-6.405 -41.792)"
  })), _use134 || (_use134 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 346.925,
    y: 590.52,
    transform: "translate(-6.405 -41.792)"
  })), _use135 || (_use135 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 367.205,
    y: 590.52,
    transform: "translate(-6.405 -41.792)"
  })), _use136 || (_use136 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 379.325,
    y: 590.52,
    transform: "translate(-6.405 -41.792)"
  })), _use137 || (_use137 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 428.045,
    y: 590.52,
    transform: "translate(-6.405 -41.792)"
  })), _use138 || (_use138 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 471.365,
    y: 590.52,
    transform: "translate(-6.405 -41.792)"
  })), _use139 || (_use139 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 485.405,
    y: 590.52,
    transform: "translate(-6.405 -41.792)"
  })), _use140 || (_use140 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 511.446,
    y: 590.52,
    transform: "translate(-6.405 -41.792)"
  })), _use141 || (_use141 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 107.637,
    y: 603.12,
    transform: "translate(-6.405 -41.792)"
  })), _use142 || (_use142 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 127.433,
    y: 603.12,
    transform: "translate(-6.405 -41.792)"
  })), _use143 || (_use143 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 150.714,
    y: 603.12,
    transform: "translate(-6.405 -41.792)"
  })), _use144 || (_use144 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 190.19,
    y: 603.12,
    transform: "translate(-6.405 -41.792)"
  })), _use145 || (_use145 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 209.987,
    y: 603.12,
    transform: "translate(-6.405 -41.792)"
  })), _use146 || (_use146 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 247.423,
    y: 603.12,
    transform: "translate(-6.405 -41.792)"
  })), _use147 || (_use147 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 286.663,
    y: 603.12,
    transform: "translate(-6.405 -41.792)"
  })), _use148 || (_use148 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 317.862,
    y: 603.12,
    transform: "translate(-6.405 -41.792)"
  })), _use149 || (_use149 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 331.542,
    y: 603.12,
    transform: "translate(-6.405 -41.792)"
  })), _use150 || (_use150 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 391.413,
    y: 603.12,
    transform: "translate(-6.405 -41.792)"
  })), _use151 || (_use151 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 408.333,
    y: 603.12,
    transform: "translate(-6.405 -41.792)"
  })), _use152 || (_use152 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 460.523,
    y: 603.12,
    transform: "translate(-6.405 -41.792)"
  })), _use153 || (_use153 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 489.803,
    y: 603.12,
    transform: "translate(-6.405 -41.792)"
  })), _use154 || (_use154 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 509.96,
    y: 603.12,
    transform: "translate(-6.405 -41.792)"
  })), _use155 || (_use155 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 522.079,
    y: 603.12,
    transform: "translate(-6.405 -41.792)"
  })), _use156 || (_use156 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 90.479,
    y: 615.72,
    transform: "translate(-6.405 -41.792)"
  })), _use157 || (_use157 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 115.08,
    y: 615.72,
    transform: "translate(-6.405 -41.792)"
  })), _use158 || (_use158 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 143.047,
    y: 615.72,
    transform: "translate(-6.405 -41.792)"
  })), _use159 || (_use159 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 206.29,
    y: 615.72,
    transform: "translate(-6.405 -41.792)"
  })), _use160 || (_use160 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 267.72,
    y: 615.72,
    transform: "translate(-6.405 -41.792)"
  })), _use161 || (_use161 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 427.32,
    y: 615.72,
    transform: "translate(-6.405 -41.792)"
  })), _use162 || (_use162 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k",
    x: 47.04,
    y: 633.72,
    transform: "translate(-6.405 -41.792)"
  })), _use163 || (_use163 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 220.57,
    y: 634.08,
    transform: "translate(-6.405 -41.792)"
  })), _use164 || (_use164 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 471.493,
    y: 634.08,
    transform: "translate(-6.405 -41.792)"
  })), _use165 || (_use165 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 90.117,
    y: 646.68,
    transform: "translate(-6.405 -41.792)"
  })), _use166 || (_use166 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 244.205,
    y: 646.68,
    transform: "translate(-6.405 -41.792)"
  })), _use167 || (_use167 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 269.401,
    y: 646.68,
    transform: "translate(-6.405 -41.792)"
  })), _use168 || (_use168 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 429.12,
    y: 646.68,
    transform: "translate(-6.405 -41.792)"
  })), _use169 || (_use169 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k",
    x: 47.04,
    y: 664.56,
    transform: "translate(-6.405 -41.792)"
  })), _use170 || (_use170 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 163.2,
    y: 664.92,
    transform: "translate(-6.405 -41.792)"
  })), _use171 || (_use171 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 234.6,
    y: 664.92,
    transform: "translate(-6.405 -41.792)"
  })), _use172 || (_use172 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 316.55,
    y: 664.92,
    transform: "translate(-6.405 -41.792)"
  })), _use173 || (_use173 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 376.809,
    y: 664.92,
    transform: "translate(-6.405 -41.792)"
  })), _use174 || (_use174 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 398.41,
    y: 664.92,
    transform: "translate(-6.405 -41.792)"
  })), _use175 || (_use175 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 504.859,
    y: 664.92,
    transform: "translate(-6.405 -41.792)"
  })), _use176 || (_use176 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    x: 213.24,
    y: 675.36,
    transform: "translate(-6.405 -41.792)"
  })), _use177 || (_use177 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j",
    x: 214.56,
    y: 675.36,
    fill: "#512eab",
    transform: "translate(-6.405 -41.792)"
  })), _use178 || (_use178 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k",
    x: 53.156,
    y: 693.36,
    transform: "translate(-6.405 -41.792)"
  })), _use179 || (_use179 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 65.16,
    y: 693.36,
    transform: "translate(-6.405 -41.792)"
  })), _use180 || (_use180 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 113.88,
    y: 693.36,
    transform: "translate(-6.405 -41.792)"
  })), _use181 || (_use181 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 162.481,
    y: 693.36,
    transform: "translate(-6.405 -41.792)"
  })), _use182 || (_use182 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 190.561,
    y: 693.36,
    transform: "translate(-6.405 -41.792)"
  })), _use183 || (_use183 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 239.402,
    y: 693.36,
    transform: "translate(-6.405 -41.792)"
  })), _use184 || (_use184 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 249.123,
    y: 693.36,
    transform: "translate(-6.405 -41.792)"
  })), _use185 || (_use185 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 300.844,
    y: 693.36,
    transform: "translate(-6.405 -41.792)"
  })), _use186 || (_use186 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 330.005,
    y: 693.36,
    transform: "translate(-6.405 -41.792)"
  })), _use187 || (_use187 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 361.205,
    y: 693.36,
    transform: "translate(-6.405 -41.792)"
  })), _use188 || (_use188 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 374.885,
    y: 693.36,
    transform: "translate(-6.405 -41.792)"
  })), _use189 || (_use189 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 398.045,
    y: 693.36,
    transform: "translate(-6.405 -41.792)"
  })), _use190 || (_use190 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 435.606,
    y: 693.36,
    transform: "translate(-6.405 -41.792)"
  })), _use191 || (_use191 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 474.847,
    y: 693.36,
    transform: "translate(-6.405 -41.792)"
  })), _use192 || (_use192 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 506.047,
    y: 693.36,
    transform: "translate(-6.405 -41.792)"
  })), _use193 || (_use193 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 519.727,
    y: 693.36,
    transform: "translate(-6.405 -41.792)"
  })), _use194 || (_use194 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 160.31,
    y: 705.96,
    transform: "translate(-6.405 -41.792)"
  })), _use195 || (_use195 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 216.115,
    y: 705.96,
    transform: "translate(-6.405 -41.792)"
  })), _use196 || (_use196 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 355.446,
    y: 705.96,
    transform: "translate(-6.405 -41.792)"
  })), _use197 || (_use197 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 387.845,
    y: 705.96,
    transform: "translate(-6.405 -41.792)"
  })), _use198 || (_use198 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 406.565,
    y: 705.96,
    transform: "translate(-6.405 -41.792)"
  })), _use199 || (_use199 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 494.88,
    y: 705.96,
    transform: "translate(-6.405 -41.792)"
  })), _use200 || (_use200 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 127.688,
    y: 718.56,
    transform: "translate(-6.405 -41.792)"
  })), _use201 || (_use201 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    x: 236.88,
    y: 718.56,
    transform: "translate(-6.405 -41.792)"
  })), _use202 || (_use202 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j",
    x: 396.12,
    y: 718.56,
    fill: "#512eab",
    transform: "translate(-6.405 -41.792)"
  })), _use203 || (_use203 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k",
    x: 47.04,
    y: 736.44,
    transform: "translate(-6.405 -41.792)"
  })), _use204 || (_use204 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 89.161,
    y: 736.8,
    transform: "translate(-6.405 -41.792)"
  })), _use205 || (_use205 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 138.362,
    y: 736.8,
    transform: "translate(-6.405 -41.792)"
  })), _use206 || (_use206 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 181.082,
    y: 736.8,
    transform: "translate(-6.405 -41.792)"
  })), _use207 || (_use207 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 207.003,
    y: 736.8,
    transform: "translate(-6.405 -41.792)"
  })), _use208 || (_use208 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 255.964,
    y: 736.8,
    transform: "translate(-6.405 -41.792)"
  })), _use209 || (_use209 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 274.804,
    y: 736.8,
    transform: "translate(-6.405 -41.792)"
  })), _use210 || (_use210 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 386.51,
    y: 736.8,
    transform: "translate(-6.405 -41.792)"
  })), _use211 || (_use211 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 406.676,
    y: 736.8,
    transform: "translate(-6.405 -41.792)"
  })), _use212 || (_use212 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: 451.796,
    y: 736.8,
    transform: "translate(-6.405 -41.792)"
  })), _use213 || (_use213 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 123.362,
    y: 749.4,
    transform: "translate(-6.405 -41.792)"
  })), _use214 || (_use214 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 156.244,
    y: 749.4,
    transform: "translate(-6.405 -41.792)"
  })), _use215 || (_use215 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 192.124,
    y: 749.4,
    transform: "translate(-6.405 -41.792)"
  })), _use216 || (_use216 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 201.845,
    y: 749.4,
    transform: "translate(-6.405 -41.792)"
  })), _use217 || (_use217 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 241.204,
    y: 749.4,
    transform: "translate(-6.405 -41.792)"
  })), _use218 || (_use218 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 280.447,
    y: 749.4,
    transform: "translate(-6.405 -41.792)"
  })), _use219 || (_use219 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 311.527,
    y: 749.4,
    transform: "translate(-6.405 -41.792)"
  })), _use220 || (_use220 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 325.327,
    y: 749.4,
    transform: "translate(-6.405 -41.792)"
  })), _use221 || (_use221 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 332.647,
    y: 749.4,
    transform: "translate(-6.405 -41.792)"
  })), _use222 || (_use222 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 358.687,
    y: 749.4,
    transform: "translate(-6.405 -41.792)"
  })), _use223 || (_use223 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 395.769,
    y: 749.4,
    transform: "translate(-6.405 -41.792)"
  })), _use224 || (_use224 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 405.49,
    y: 749.4,
    transform: "translate(-6.405 -41.792)"
  })), _use225 || (_use225 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 424.93,
    y: 749.4,
    transform: "translate(-6.405 -41.792)"
  })), _use226 || (_use226 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 452.531,
    y: 749.4,
    transform: "translate(-6.405 -41.792)"
  })), _use227 || (_use227 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    x: 487.931,
    y: 749.4,
    transform: "translate(-6.405 -41.792)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPearsonLogoPurple);
export default __webpack_public_path__ + "static/media/Pearson_Logo_Purple.18a3d2945cab103077f467e704fb4100.svg";
export { ForwardRef as ReactComponent };